import usePopupStore from "src/swsh-native/Popups/stores/usePopupStore";

const popupCloseSelf = ({ id }: { id: string }) => {
	usePopupStore.getState().removePopup(id);
};
export default popupCloseSelf;
